import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

// Цветовые схемы
export const themes = {
  light: {
    background: '#f6f8ff',
    surface: '#ffffff',
    text: '#102067',
    textSecondary: '#53658d',
    border: '#d5def3',
    primary: '#0d2bff',
    primaryDark: '#bd1e7b',
    cardShadow: 'rgba(13, 43, 255, 0.05) 0 1px 2px 0 inset'
  },
  dark: {
    background: '#07143c',
    surface: '#0c215b',
    text: '#ffffff',
    textSecondary: '#c8d7fb',
    border: '#24427d',
    primary: '#0d2bff',
    primaryDark: '#bd1e7b',
    cardShadow: 'rgba(99, 159, 233, 0.12) 0 1px 2px 0 inset'
  }
};

export function ThemeProvider({ children }) {
  // Загружаем сохраненную тему из localStorage
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  // Сохраняем тему при изменении
  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.dataset.theme = theme;
    // Применяем тему к body
    document.body.style.backgroundColor = themes[theme].background;
    document.body.style.color = themes[theme].text;
  }, [theme]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const baseUrl = process.env.REACT_APP_CLIENT_CORE_API_URL || '';
    fetch(`${baseUrl}/v1/clients/users/me/preferences`, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        const saved = data?.preferences?.theme;
        if (saved === 'light' || saved === 'dark') setTheme(saved);
      })
      .catch(() => undefined);
  }, []);

  const toggleTheme = () => {
    setTheme(prev => {
      const next = prev === 'light' ? 'dark' : 'light';
      const token = localStorage.getItem('token');
      const baseUrl = process.env.REACT_APP_CLIENT_CORE_API_URL || '';
      if (token) {
        fetch(`${baseUrl}/v1/clients/users/me/preferences`, {
          method: 'PUT',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ theme: next }),
        }).catch(() => undefined);
      }
      return next;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, currentTheme: themes[theme] }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
